import { useCallback, useState } from 'react';

export function useLastCalculated<Fields>(): {
  wasLastCalculated: (field: Fields) => boolean;
  setLastCalculated: (fields: Array<Fields>) => void;
  lastCalculated: Array<Fields>;
} {
  const [lastCalculated, setLastCalculated] = useState<Array<Fields>>([]);

  const wasLastCalculated = useCallback(
    (field: Fields) => {
      return lastCalculated.indexOf(field) > -1;
    },
    [lastCalculated],
  );

  return { wasLastCalculated, setLastCalculated, lastCalculated };
}
